import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { useOnCrmMessageTopic } from 'crm-message-bus/useOnCrmMessageTopic';
import { useCallback, useMemo, useState } from 'react';
import { logIfIframe } from '../utils/logIfIframe';

// This creates a union type of all modal handlers for all topics.
// This is similar to saying `type ModalHandlerForAnyTopic = ModalTopicHandler<TopicName>
// Except the former resolves to `ModalTopicHandler<'PREVIEW_OBJECT' | 'OPEN_ACTIVITY_CREATOR' | ...>`
// whereas the below type resolves to `ModalTopicHandler<'PREVIEW_OBJECT'> | 'ModalTopicHandler<'OPEN_ACTIVITY_CREATOR'> | ...`
// which leads to better type narrowing inside the ModalRegistration component.
import { jsx as _jsx } from "react/jsx-runtime";
function loaderWithErrorLogger(componentLoader) {
  return () => {
    return componentLoader().catch(error => {
      // Without logging this here the error gets swallowed by the async import
      console.error(error);
      throw error;
    });
  };
}
export default function ModalRegistration({
  features,
  handler,
  i18nLoader,
  onCommunicatorClick,
  usageTracker
}) {
  const [showModal, setShowModal] = useState(false);
  const [messageData, setMessageData] = useState();
  const onMessage = useCallback(data => {
    logIfIframe('ModalRegistration handled message in an iframe', {
      topic: handler.topic
    });
    setMessageData(data);
    setShowModal(true);
  }, [handler.topic]);
  useOnCrmMessageTopic(handler.topic, onMessage);
  const onClose = useCallback(() => {
    setShowModal(false);
  }, [setShowModal]);
  const LoadableContentComponent = useMemo(() => Loadable({
    loader: loaderWithErrorLogger(handler.componentLoader)
  }), [handler.componentLoader]);
  if (showModal) {
    return /*#__PURE__*/_jsx(LoadableContentComponent, {
      onClose: onClose,
      data: messageData,
      features: features,
      i18nLoader: i18nLoader,
      onCommunicatorClick: onCommunicatorClick,
      usageTracker: usageTracker
    });
  }
  return null;
}